import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "innerbox"
};
const _hoisted_2 = {
  class: "imgTxtbox"
};
const _hoisted_3 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "txtbox"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "textover"
};
const _hoisted_8 = {
  class: "textover"
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  class: "textover"
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  class: "textover"
};
const _hoisted_13 = ["href"];
const _hoisted_14 = {
  key: 2,
  class: "more",
  href: "javascript:void(0)"
};
const _hoisted_15 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", null, [_ctx.$attrs.popshowflag && _ctx.$attrs.detail ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(["popcontainer-style1", [{
      'rightTop': $data.rightTopflag
    }, {
      'mobile': _ctx.$attrs.isMobile
    }]])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_ctx.$attrs.detail.thumb.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.$attrs.detail.thumb[0].fileUrl,
    alt: ""
  }, null, 8, _hoisted_4), _createElementVNode("span", null, _toDisplayString(_ctx.$attrs.detail.level), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, [_createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$attrs.detail.title), 1), _createElementVNode("ul", null, [_createElementVNode("li", null, [_createElementVNode("span", _hoisted_7, "类别：" + _toDisplayString(_ctx.$attrs.detail.category), 1)]), _createElementVNode("li", null, [_createElementVNode("span", _hoisted_8, "批次：" + _toDisplayString(_ctx.$attrs.detail.batch), 1)]), $data.query.formUserId === '1083493444' ? (_openBlock(), _createElementBlock("li", _hoisted_9, [_createElementVNode("span", _hoisted_10, "申报地区或单位：" + _toDisplayString($options.get47data(_ctx.$attrs.detail[46])), 1)])) : (_openBlock(), _createElementBlock("li", _hoisted_11, [_createElementVNode("span", _hoisted_12, "申报地区或单位：" + _toDisplayString(`${_ctx.$attrs.detail.address},${_ctx.$attrs.detail.protection_unit}`), 1)]))])])]), _ctx.$attrs.detail.gateway !== '' && $data.query.fid === '249081' ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    class: "more",
    href: "javascript:void(0);",
    onClick: _cache[0] || (_cache[0] = $event => $options.goLink(_ctx.$attrs.detail.gateway))
  }, _cache[1] || (_cache[1] = [_createTextVNode("查看详情"), _createElementVNode("i", {
    class: "icon-arrow-bottom1"
  }, null, -1)]))) : _ctx.$attrs.detail.gateway !== '' ? (_openBlock(), _createElementBlock("a", {
    key: 1,
    class: "more",
    href: _ctx.$attrs.detail.gateway
  }, _cache[2] || (_cache[2] = [_createTextVNode("查看详情"), _createElementVNode("i", {
    class: "icon-arrow-bottom1"
  }, null, -1)]), 8, _hoisted_13)) : (_openBlock(), _createElementBlock("a", _hoisted_14, _cache[3] || (_cache[3] = [_createTextVNode("查看详情"), _createElementVNode("i", {
    class: "icon-arrow-bottom1"
  }, null, -1)])))])], 2)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: $data.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_15), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("返回")])),
    _: 1
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])]);
}